import { ArrayOps, NumberOps } from '../lift';
/**
 * Counts the items satisfying a predicate.
 */
export function count(predicate) {
    var arr = this.value(), result = 0;
    for (var i = 0; i < arr.length; i++) {
        if (predicate(arr[i], i))
            result++;
    }
    return new NumberOps(result);
}
ArrayOps.prototype.count = count;
